module.exports = __webpack_public_path__ + "img/packshots-mobile(old).65cf7100.png";